export function isAPIApplicationException(error: any): boolean {
    return (
        error?.title &&
        error?.status === 400 &&
        error?.type === 'https://tools.ietf.org/html/rfc7231#section-6.5.1'
    );
}
